// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run pnpm gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SportsbetUpdateLanguageMutationVariables = Types.Exact<{
  id: Types.Scalars['GraphqlId']['input'];
  language: Types.Scalars['String']['input'];
  site: Types.Scalars['String']['input'];
}>;


export type SportsbetUpdateLanguageMutation = { __typename?: 'Mutation', sportsbetPreferencesUpdateLanguage?: { __typename?: 'SportsbetPreferencesUpdateLanguagePayload', userPreferences?: { __typename?: 'SportsbetPreferencesUserPreference', id: string, language?: string } } };


export const SportsbetUpdateLanguageMutationDocument = /*#__PURE__*/ gql`
    mutation SportsbetUpdateLanguageMutation($id: GraphqlId!, $language: String!, $site: String!) {
  sportsbetPreferencesUpdateLanguage(
    input: {id: $id, language: $language, site: $site}
  ) {
    userPreferences {
      id
      language
    }
  }
}
    `;
export type SportsbetUpdateLanguageMutationMutationFn = Apollo.MutationFunction<SportsbetUpdateLanguageMutation, SportsbetUpdateLanguageMutationVariables>;
export function useSportsbetUpdateLanguageMutation(baseOptions?: Apollo.MutationHookOptions<SportsbetUpdateLanguageMutation, SportsbetUpdateLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SportsbetUpdateLanguageMutation, SportsbetUpdateLanguageMutationVariables>(SportsbetUpdateLanguageMutationDocument, options);
      }
export type SportsbetUpdateLanguageMutationHookResult = ReturnType<typeof useSportsbetUpdateLanguageMutation>;
export type SportsbetUpdateLanguageMutationMutationResult = Apollo.MutationResult<SportsbetUpdateLanguageMutation>;
export type SportsbetUpdateLanguageMutationMutationOptions = Apollo.BaseMutationOptions<SportsbetUpdateLanguageMutation, SportsbetUpdateLanguageMutationVariables>;